import React, {PropsWithChildren, useEffect, useState} from "react";
import {observer} from "mobx-react";
import {ISheetModalDialogRenderer} from "../../services/dialog/dialog.service.interface";
import ReactModal, {Styles as ReactModalStyles} from "react-modal";
import {getCommonModalContentStyles, getCommonModalOverlayStyles} from "./common-modal-content-styles";
import {IServiceFactory} from "../../services/service-factory.interface";
import {useServices} from "../../hooks/use-services.hook";

interface SheetModalDialogComponentProps extends PropsWithChildren {
    renderer: ISheetModalDialogRenderer;
    backdropDismiss: boolean;
    breakpoints: number[];
    showHandle: boolean;
}

export const SheetModalDialogComponent: React.FC<SheetModalDialogComponentProps> = observer((props) => {
    const services = useServices();
    const [isAnimated, setIsAnimated] = useState(false);


    useEffect(() => {
        setIsAnimated(true);
    }, [])

    const captureElementRef = (element: any) => {
        props.renderer.attachElementRef(element)
    }

    const onDismissHandler = () => {
        props.renderer.onBackdropDismiss();
    }

    let top = (100 - props.breakpoints[0] * 100) + '%';
    const styles: ReactModalStyles = {
        content: {
            ...getCommonModalContentStyles(),
            ...computePositioning(services),
            borderTopLeftRadius: services.theme.currentTheme.border.defaultRadius,
            borderTopRightRadius: services.theme.currentTheme.border.defaultRadius,
            border: "none",
            backgroundColor: services.theme.currentTheme.colors.dialogContentBackground,
            color: services.theme.currentTheme.colors.dialogContentColor,
            transition: 'top 0.2s ease-in-out',
            top: isAnimated ? top : '100%',
        },
        overlay: {
            ...getCommonModalOverlayStyles(services)
        }
    }

    return (
        <ReactModal key={props.renderer.id}
                    id={props.renderer.id}
                    ref={captureElementRef}
                    isOpen={props.renderer.isOpen}
                    style={styles}
                    shouldCloseOnOverlayClick={props.backdropDismiss}
                    onAfterClose={onDismissHandler}
                    onRequestClose={onDismissHandler}
                    //handle={props.showHandle}
                     //breakpoints={props.breakpoints}
                     //initialBreakpoint={initialBreakpoint}
        >
            {props.children}
        </ReactModal>
    )
});

function computePositioning(services: IServiceFactory): React.CSSProperties {



    if(services.screenMediaQuery.sAndBelow) {
        return {
            bottom: 0,
            left: 0,
            right: 0

        }
    }
    if(services.screenMediaQuery.mAndBelow) {
        return {
            bottom: 0,
            right: '10%',
            left: '10%',
        }
    }

    if(services.screenMediaQuery.lAndBelow) {
        return {
            bottom: 0,
            right: '15%',
            left: '15%',
        }
    }

    return {
        bottom: 0,
        right: '25%',
        left: '25%',
    }

}